import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 20px;
  background: linear-gradient(
    135deg,
    rgba(122, 5, 167, 0.05) 0%,
    rgba(122, 5, 167, 0.02) 100%
  );
`;

export const IconContainer = styled.div`
  margin-bottom: 40px;
  animation: float 3s ease-in-out infinite;

  @keyframes float {
    0%,
    100% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(-20px);
    }
  }
`;

export const Title = styled.h1`
  font-size: 48px;
  font-weight: 700;
  color: var(--colorButton);
  margin: 0 0 16px 0;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 32px;
  }
`;

export const Description = styled.p`
  font-size: 18px;
  color: #666;
  text-align: center;
  margin: 0 0 40px 0;
  max-width: 500px;
  line-height: 1.6;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const Button = styled.button`
  padding: 12px 40px;
  font-size: 16px;
  font-weight: 600;
  background-color: var(--colorButton);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(122, 5, 167, 0.2);

  &:hover {
    background-color: var(--colorButton);
    opacity: 0.9;
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(122, 5, 167, 0.3);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    padding: 10px 30px;
    font-size: 14px;
  }
`;
